export function find<A>(ary: A[], predicate: (a: A) => boolean): A | undefined {
  for (let i = 0; i < ary.length; i++) {
    const element = ary[i];
    if (predicate(element)) {
      return element;
    }
  }

  return undefined;
}
